import { render, staticRenderFns } from "./salarySlice.vue?vue&type=template&id=485582e8&"
import script from "./salarySlice.vue?vue&type=script&lang=js&"
export * from "./salarySlice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports